module.exports = __webpack_public_path__ + "static/media/html-css-javascript.d50d7f97.jpg";